<template>
  <div id="app">
    <HeaderCompo />
    <template>
      <div
        id="contact_page"
        class="container"
      >
        <div class="box contact">
          <center>
            <h3 id="contact_title">
              Contact Us
            </h3>
            <p>
              We would love to hear from you, feel free to write us at <a href="mailto:bestiefy@gmail.com">
                bestiefy@gmail.com
              </a>
            </p>
          </center>
        </div>
        <div
          id="div_delete_button"
          class="delete_button_shadow go_back_button"
        >
          <button
            id="backButton"
            class="fullWidthButton button_2 pushdown "
            type="button"
            @click="goBack()"
          >
            {{ $t("answers.back") }}
          </button>
        </div>
      </div>
    </template>
    <FlyCompo />
    <FooterCompo />
  </div>
</template>

<script>
import HeaderCompo from '@/components/HeaderCompo.vue'
import FooterCompo from '@/components/FooterCompo.vue'
import FlyCompo from '@/components/FlyCompo.vue'

export default {
  name: 'Contact',
  components: {
    HeaderCompo,
    FooterCompo,
    FlyCompo
  },
  methods: {
    goBack () {
      window.location.href = '/'
    }
  }
}
</script>

<style lang="scss">
</style>
